import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    var EmptyTips = computed(function () {
      if (applyService.formState.contestScheduleId) {
        return '暂无数据，请选择其他组别';
      }
      return '请先选择组别';
    });
    return function (_ctx, _cache) {
      var _component_a_cascader = _resolveComponent("a-cascader");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfArea.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 24
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "学校所在地区：",
            name: "area",
            "wrapper-col": {
              span: 6
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_cascader, {
                allowClear: "",
                size: "large",
                key: _unref(formState).contestScheduleId + '@init',
                value: _unref(formState).area,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).area = $event;
                }),
                onChange: _unref(applyService).onAreaChange,
                options: _unref(applyService).areaList,
                "load-data": _unref(applyService).loadAreaData,
                "field-names": {
                  label: 'areaName',
                  value: 'id',
                  children: 'children'
                },
                placeholder: "学校所在地区",
                "not-found-content": _unref(EmptyTips)
              }, null, 8, ["value", "onChange", "options", "load-data", "not-found-content"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});